import { useState } from "react";

const Branch = ({ index, branchInfo }) => {
    const [open, setOpen] = useState(false);

    return (
        <div data-testid={`Branch-${index}`} className={`branch-${index}`}>
            {(branchInfo && !branchInfo.confirmExit) &&
                <a data-testid="Branch--Anchor" href={branchInfo.url} target="_blank" rel="noreferrer">
                    <div className="branch-container">
                        {branchInfo.title}
                    </div>
                </a>
            }

            {(branchInfo && branchInfo.confirmExit) &&
                <div>
                    <div data-testid="Branch--ConfirmExitTitle" className={`branch-container ${open ? 'confirm-open' : ''}`} onClick={() => setOpen(open => !open)}>
                        {branchInfo.title}
                    </div>
                    {open &&
                        <div data-testid="Branch--ConfirmExitDropdown" className="branch-container-confirm">
                            <p>{`Open ${branchInfo.title}?`}</p>
                            <button data-testid="Branch--ConfirmExitDropdown-ConfirmButton" className="branch-container-confirm-continue" onClick={() => window.open(branchInfo.url, "_blank")}>Continue</button>
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default Branch;